import "./commonform.css";

import React, { useEffect, useState } from "react";

import { API_URL } from "../../../env";
import axios from "axios";

const CommonForm = (params) => {
  const [formJSON, setFormJSON] = useState([]);

  useEffect(() => {
    setFormJSON(params.data);
  }, [params.data]);

  const handleChange = (key, value) => {
    setFormJSON((prevForm) =>
      prevForm.map((field) => (field.key === key ? { ...field, value } : field))
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let payload = {}
    formJSON.forEach((i,j) => {
        payload[i.key] = i.value
    });

   try {
      const res = await axios.post(`${API_URL}${params.postUrl}`, payload, {
        headers: {
          'env': 'local'
        }
      });

      if (res) {
        sessionStorage.setItem('token', res.data.token)
        params.onSuccess?.(res.data, payload);
      }
    } catch (error) {
      console.error("Failed to update profile:", error);
    }
  };

  const renderField = (element) => {
    const label = element.label;
    const helper = element.required ? "Required" : "Optional";

    if (element.type === "select") {
      return (
        <label className="cf-field" key={element.key}>
          <span>
            <strong>{label}</strong>
            <small>{helper}</small>
          </span>
          <select
            value={element.value || ""}
            onChange={(event) => handleChange(element.key, event.target.value)}
            required={element.required}
            disabled={element.disabled}
            aria-label={label}
          >
            <option value="">Select</option>
            {(element.options || []).map((option) => (
              <option key={`${option.value}-${option.text}`} value={option.value}>
                {option.text}
              </option>
            ))}
          </select>
        </label>
      );
    }

    if (element.type === "checkbox") {
      return (
        <label className="cf-checkbox" key={element.key}>
          <input
            type="checkbox"
            checked={Boolean(element.value)}
            onChange={(event) => handleChange(element.key, event.target.checked)}
            disabled={element.disabled}
          />
          <span>{label}</span>
        </label>
      );
    }

    if (element.type === "radio") {
      return (
        <div className="cf-field" key={element.key}>
          <span>{label}</span>
          <div className="cf-radio-group">
            {(element.options || []).map((option) => (
              <label className="cf-radio" key={`${element.key}-${option.value}`}>
                <input
                  type="radio"
                  name={element.key}
                  value={option.value}
                  checked={element.value === option.value}
                  onChange={(event) => handleChange(element.key, event.target.value)}
                  disabled={element.disabled}
                />
                <span>{option.text}</span>
              </label>
            ))}
          </div>
        </div>
      );
    }

    if (element.type === "textarea") {
      return (
        <label className="cf-field cf-field-full" key={element.key}>
          <span>
            <strong>{label}</strong>
            <small>{helper}</small>
          </span>
          <textarea
            rows={4}
            value={element.value || ""}
            onChange={(event) => handleChange(element.key, event.target.value)}
            required={element.required}
            disabled={element.disabled}
            aria-label={label}
            placeholder={element.placeholder || `Enter ${label}`}
          />
        </label>
      );
    }

    return (
      <label className="cf-field" key={element.key}>
        <span>
          <strong>{label}</strong>
          <small>{helper}</small>
        </span>
        <input
          type={element.type || "text"}
          value={element.value || ""}
          onChange={(event) => handleChange(element.key, event.target.value)}
          required={element.required}
          disabled={element.disabled}
          aria-label={label}
          autoComplete="off"
          placeholder={element.placeholder || `Enter ${label}`}
        />
      </label>
    );
  };

  return (
    <section className="cf-shell">
      {params.heading && <h2 className="cf-heading">{params.heading}</h2>}

      {formJSON && formJSON.length > 0 ? (
        <form className="cf-form" onSubmit={handleSubmit} autoComplete="off">
          <div className="cf-grid">{formJSON.map((element) => renderField(element))}</div>

          <button type="submit" className="vb-btn vb-btn-primary cf-submit-btn">
            Update
          </button>
        </form>
      ) : (
        <p className="cf-empty">No Data Found</p>
      )}
    </section>
  );
};

export default CommonForm;
